export default __webpack_public_path__ + "static/media/catago-screenshot-04.67fc1e5a.png";